import { useMemo } from 'react';
import { useQuotaQuery } from '@entities/Plan';
import { choicePrice, type ChoicePrice } from './choicePrice';

/** Цена нажатия и строка о жетонах (`choicePrice`) по свежей квоте. Квоту компонент читает сам, как `WordSpotlight`. */
export function useChoicePrice(count: number, needsGeneration: boolean): ChoicePrice {
  const { data: quota } = useQuotaQuery();
  return useMemo(() => choicePrice({ count, needsGeneration, quota }), [count, needsGeneration, quota]);
}
